import { useCallback, type Dispatch, type SetStateAction } from "react";
import type { HandleSelectChange, SelectValues } from "ui-kit/src/MultipleSelect/types";
import type { ProgramGameFormState } from "../types";

export function useProgramGameFormLinkHandlers(
	setForm: Dispatch<SetStateAction<ProgramGameFormState>>,
) {
	const handleOwnershipChange: HandleSelectChange = useCallback(
		(selected) => {
			setForm((prev) => ({
				...prev,
				ownershipSelections: (selected ?? []) as SelectValues,
			}));
		},
		[setForm],
	);

	const setTeamsheetLinkAt = useCallback(
		(index: number, value: string): void => {
			setForm((prev) => {
				const links = [...prev.teamsheetLinks];
				links[index] = { ...links[index], value };
				return { ...prev, teamsheetLinks: links };
			});
		},
		[setForm],
	);

	const setVideoLinkAt = useCallback(
		(index: number, value: string): void => {
			setForm((prev) => {
				const links = [...prev.videoLinks];
				links[index] = { ...links[index], value };
				return { ...prev, videoLinks: links };
			});
		},
		[setForm],
	);

	return { handleOwnershipChange, setTeamsheetLinkAt, setVideoLinkAt };
}
